import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=48d6be64&scoped=true&"
import script from "./LoginPage.vue?vue&type=script&lang=js&"
export * from "./LoginPage.vue?vue&type=script&lang=js&"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=48d6be64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d6be64",
  null
  
)

export default component.exports